import { render } from "./KingdomInvitation.vue?vue&type=template&id=cf6b33c6"
import script from "./KingdomInvitation.vue?vue&type=script&lang=js"
export * from "./KingdomInvitation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/embassy/windowOverlay/KingdomInvitation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf6b33c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf6b33c6', __exports__)) {
    api.reload('cf6b33c6', __exports__)
  }
  
  module.hot.accept("./KingdomInvitation.vue?vue&type=template&id=cf6b33c6", () => {
    api.rerender('cf6b33c6', render)
  })

}


export default __exports__